import { render, staticRenderFns } from "./scene4.vue?vue&type=template&id=a3fd40ac&scoped=true&"
import script from "./scene4.vue?vue&type=script&lang=ts&"
export * from "./scene4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fd40ac",
  null
  
)

export default component.exports